import { render, staticRenderFns } from "./PowraC.vue?vue&type=template&id=a6fbf1d0&scoped=true&"
import script from "./PowraC.vue?vue&type=script&lang=js&"
export * from "./PowraC.vue?vue&type=script&lang=js&"
import style0 from "./PowraC.vue?vue&type=style&index=0&id=a6fbf1d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fbf1d0",
  null
  
)

export default component.exports